module.exports = __webpack_public_path__ + "media/8.360a6c31.mp3";